import { SearchOrganizationModel } from '../../models/business/search-organization.model';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

//models
import { Organization } from '../../models/business/organization';
import { OrganizationListView } from '../../models/business/organization-list-view';
import { OrganizationView } from '@shared/models/business/organization-view';

import { HttpClient } from '@angular/common/http';
import { Address } from '../../models/peripherals/address';
import { EMail } from '../../models/peripherals/email';
import { Phone } from '../../models/peripherals/phone';
import { Dba } from '../../models/peripherals/dba';
import { Image } from '../../models/peripherals/image';
import { OrganizationType } from '../../models/peripherals/organization-type';
import { RecordManager } from '../../models/peripherals/record-manager';
import { ReferredBy } from '../../models/peripherals/referred-by';
import { Website } from '../../models/peripherals/website';
import { environment } from '../../../../environments/environment';


@Injectable()
export class OrganizationService {
  public token: string;
  loadedOrganization: { };

  constructor(private http: HttpClient) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;

   }

    get(bus_id: number): Observable<OrganizationView> {
         return this.http.get<OrganizationView>(`${environment.api}organization/${bus_id}`);
    }

    searchForOrganizations(queryData: SearchOrganizationModel) {
        return this.http.post(`${environment.api}organization/organizationsearch`, queryData);
    }

    fetchOrgNamesByTag(value: any): Observable<any> {
        return this.http.post(`${environment.api}organization/orgmap`, value);
    }
    getTotalCount(queryData: SearchOrganizationModel) {
        return this.http.post(`${environment.api}organization/orgcount`, queryData);
    }

    saveOrganization(organization): Observable<any> {
        return this.http.post(`${environment.api}organization/orginsert`, organization);
    }

    editOrganization(organization): Observable<any> {
        return this.http.put(`${environment.api}organization/orgupdate`, organization);
    }

    deleteAddress(addressId: number): Observable<any> {
        return this.http.delete(`${environment.api}address/` + addressId);
    }

    deleteEmail(emailId: number): Observable<any> {
        return this.http.delete(`${environment.api}email/` + emailId);
    }

    deletePhone(phoneId: number): Observable<any> {
        return this.http.delete(`${environment.api}phone/` + phoneId);
    }

    deleteWebsite(websiteId: number): Observable<any> {
        return this.http.delete(`${environment.api}website/` + websiteId);
    }

    deleteRecord(recordId: number): Observable<any> {
        return this.http.delete(`${environment.api}record_mgr/` + recordId);
    }

    deleteDba(dbaId: number): Observable<any> {
        return this.http.delete(`${environment.api}dba/` + dbaId);
    }

    deleteOrganization(orgId: number) {
        return this.http.delete(`${environment.api}org/` + orgId);
    }

    getContacts(org_id, contact_name) {
        return this.http.post(`${environment.api}contactbyorg/`, { 'contact_name': contact_name, 'org_id': org_id});
    }
    saveContact(insertData) {
        return this.http.post(`${environment.api}contactmap/insert`, insertData);
    }
    updateContact(insertData) {
        return this.http.post(`${environment.api}contactmap/update`, insertData);
    }
    getContactByOrg(queryData) {
        return this.http.post(`${environment.api}contactmap/list`, queryData);
    }
    deleteConMap(map_contact_id) {
        return this.http.delete(`${environment.api}contactmap/delete/` + map_contact_id);
    }
    getorgConnect(queryData) {
        return this.http.post(`${environment.api}orgconnectmap/list`, queryData);
    }
    getOrgConnectCount(queryData) {
        return this.http.post(`${environment.api}orgconnectmapping/count`, queryData);
    }
    deleteOrgConnect(orgmap_id) {
        return this.http.delete(`${environment.api}orgconnectmap/delete/` + orgmap_id);
    }
    saveOrgConnect(insertData) {
        return this.http.post(`${environment.api}orgconnectmap/insert`, insertData);
    }
    updateOrgConnect(insertData) {
        return this.http.post(`${environment.api}orgconnectmap/update`, insertData);
    }
    filterOppty(value,id,type) {
        return this.http.post(`${environment.api}opptynmauto`, { 'active': 1, 'business_id':id,'business_type_name':type, 'oppty_name': value });
    }
    filterOpptyauto(value,id,type){
        return this.http.post(`${environment.api}opptynameauto`, { 'active': 1, 'business_id':id,'business_type_name':type, 'oppty_name': value });
    }
    saveOpptyMap(insertData) {
        return this.http.post(`${environment.api}opptytmap/insert`, insertData);
    }
    updateOpptyMap(insertData) {
        return this.http.post(`${environment.api}opptytmap/update`, insertData);
    }
    getOpptyList(queryData) {
        return this.http.post(`${environment.api}opptytmap/list`, queryData);
    }
    getRecordManagers(type) {
        return this.http.post(`${environment.api}record_mgr/list`, {'type': type });
    }
    getDesignations(type) {
        return this.http.post(`${environment.api}designation/list`, { 'type': type });
    }
    getorgnamebyorg(org_id) {
        return this.http.post(`${environment.api}orgnamebyorg`, { 'org_id': org_id});
    }
    getOrgByOrgconnect(org_id, org_name) {
        return this.http.post(`${environment.api}organization/orgnamebyorgconect`, { 'org_name': org_name, 'org_id': org_id });
    }
    getContactNameFromOrg(org_id, contact_name) {
        return this.http.post(`${environment.api}contactnamebyorg/`, { 'org_id': org_id, 'contact_name': contact_name });
    }
    updateSocialMedia(insertData) {
        return this.http.put(`${environment.api}social_media/update`, insertData);
    }
    deleteGalleryImage(gallery_image_id) {
        return this.http.delete(`${environment.api}image/delete/` + gallery_image_id);
    }
    getContactMapCount(queryData) {
        return this.http.post(`${environment.api}contactmapcount`, queryData);
    }
    getOpptyMapCount(queryData) {
        return this.http.post(`${environment.api}opptytmapcount`, queryData);
    }
    getActivityMapCount(queryData) {
        return this.http.post(`${environment.api}activity/maplistcount`, queryData);
    }

    addNotesMapping(data: any) : Observable<any>{
        return this.http.post(`${environment.api}note/insert`, data);        
    }

    updateNotesMapping(data: any) : Observable<any>{
        return this.http.post(`${environment.api}note/update`, data);        
    }

    fetchNoteMappings(query: any) : Observable<any>{
        return this.http.post(`${environment.api}note/list`, query);        
    }

    getNotesMappingCount(query: any): Observable<any> {
        return this.http.post(`${environment.api}note/listcount`, query);
    }

    deleteNoteMapping(mapId) : Observable<any>{
        return this.http.delete(`${environment.api}note/delete/${mapId}`);        
    }

    getOpportunitiesByTag(query: any) : Observable<any>{
        return this.http.post(`${environment.api}opptynamefrnote`, query);        
    }

    getOrganizationsByTag(query: any) : Observable<any>{
        return this.http.post(`${environment.api}orgnamefrnote`, query);        
    }

    getContactsByTag(query: any) : Observable<any>{
        return this.http.post(`${environment.api}contactnamefrnote`, query);        
    }

    unlinkOrg(queryData){
        return this.http.post(`${environment.api}lead/unlink_org`, queryData);
    }

    createOrgContact(data){
        return this.http.post(`${environment.api}lead/update_org_con_to_lead`,data);
    }

    updateLeadMatch(query:any){
        return this.http.post(`${environment.api}leads/org_match`, query);        
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/organizations/organization.service.ts